module.exports = __webpack_public_path__ + "img/title_1.0838e8f0.png";